import { render, staticRenderFns } from "./DisconnectMessageCard.vue?vue&type=template&id=3b3047cf&"
import script from "./DisconnectMessageCard.vue?vue&type=script&lang=js&"
export * from "./DisconnectMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./DisconnectMessageCard.vue?vue&type=style&index=0&id=3b3047cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports